import {
  Box,
  Button,
  createMuiTheme,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import ResponsiveDrawer from "../Sidebar/HrSideBar";
import CoursesImg from "../images/courses-img.png";
import MicroLearnings from "../images/micro-learnings.png";
import { CertificateDownloadIcon, RightArrowIcon } from "../icons/Icons";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import "./hovereffect.css";
import { httpsCallable } from "firebase/functions";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useParams } from "react-router-dom";
import { getCookie, setCookie } from "../../Cookies";
import { functions } from "../../Firebase";
import parse from "html-react-parser";

import {
  displayOnDesktop,
  displayOnMobile,
} from "../../utilities/commonStyles/commonStyles";
import { QuizIcons } from "../../utilities/Icons/Icons";
// import "../../styles/CourseLibrary/SingleCourse.css";
// import "../../Translater/Translater";
// import Navbar from "../Navbar/Navbar";
// import ResponsiveNavbar from "../Navbar/ResponsiveNavbar";
// import CustomAccordions from "../Timeline/CustomAccordions";
import { IP } from "../../baseUrlAndConfig";
import axios from "axios";

import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { useNavigate } from "react-router";
import HrTopNavbar from "../Sidebar/HrTopNavbar";
import { ValidateAuth } from "../../AuthToken";
import HrFooter from "../Sidebar/HrFooter";
import Download from "../report/Download.svg";
import "./learning.css";
import MobileTopBar from "../Sidebar/MobaileTopBar";
import { MuiThemeProvider } from "@material-ui/core";
import { toast } from "react-toastify";
import { buildLinkedInAddToProfileUrl } from "../../utilities/Certificate/certificate.utils";
import { LinkedIn } from "@material-ui/icons";
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#E4E0F7",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#4F279B" : "#4F279B",
  },
}));

function ProgressBars({ progress }) {
  let value = progress?.total
    ? Math.ceil((progress?.completed / progress?.total) * 100)
    : "0";
  return (
    <Box sx={{ flexGrow: 1 }}>
      <BorderLinearProgress
        variant="determinate"
        value={value}
        sx={{ background: "#4F279B" }}
      />
    </Box>
  );
}

const CourseContent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ValidateAuth();
    // let newobj = JSON.parse(getCookie("roles"));
    // // console.log(newobj.HRDI);
    // if (!newobj.LEARNING?.includes(getCookie("ROLE"))) {
    //   goToHome();
    //   return <></>;
    // }
  }, []);

  const location = useLocation();

  const getCourseInfo = httpsCallable(functions, "getCourseInfo");
  const getQuizInfo = httpsCallable(functions, "getQuizInfo");
  const userEnrollment = httpsCallable(functions, "userEnrollment");
  const getNodeProgress = httpsCallable(functions, "getNodeProgress");
  const fetchCourseCertificate = httpsCallable(
    functions,
    "fetchCourseCertificate",
  );
  // userEnrollment
  const [courseInfo, setCourseInfo] = useState(null);
  const [progress, setProgress] = useState(null);
  const [userDueDate, setUserDueDate] = useState("");
  const [lessonsInfo, setLessonsInfo] = useState([]);

  const [certificateInfo, setCertificateInfo] = useState(null);
  const courseId = location.state.courseId;
  const [disclaimerRead, setDisclaimerRead] = useState(false);

  const { clrs } = useSelector((state) => state.createClr);
  const [courseQuiz, setCourseQuiz] = useState([]);
  const { t } = useTranslation();
  const [flagForComplitedCourse, setFlagForComplitedCourse] = useState("");
  const enrollUser = (data) => {
    //if user is already enrolled then redirect to course content page
    console.log("dayta", data);
    if (user_courses && data != "Start") {
      localStorage.removeItem(courseId);

      navigate(`/hr/Learning/course-content/course/${courseId}`, {
        state: {
          courseStatus: data == "Completed" ? true : false,
          certificateInfo: certificateInfo?.certificateDownloadURL,
          courseInfo: courseInfo,
        },
      });
      return;
    }
    //if user is not enrolled then enroll user

    let dueDate = new Date(
      Number(new Date()) +
        1000 * 60 * 60 * 24 * courseInfo.extraInfo.courseExpirationDays,
    );

    if (data == "Start") {
      let configrecrut = {
        method: "post",
        data: JSON.stringify({
          startDate: new Date().toString(),
          dueDate: dueDate.toString(),
          courseId: courseId,
          courseName: courseInfo.courseName,
          trainingProvider: courseInfo.extraInfo.trainingProvider,
        }),
        url: `${IP}/userEnrollment`,
        params: { courseId: courseId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        //data: "dataregionf",
      };
      axios(configrecrut).then((res) => {
        console.log("");
      });
    }

    // alert("Enrolled Rahul");
    localStorage.removeItem(courseId);

    navigate(`/hr/Learning/course-content/course/${courseId}`, {
      state: {
        courseInfo: courseInfo,
      },
    });
  };

  // useEffect(() => {
  //   if (getCookie("UID") == null || getCookie("ROLE") != "user") {
  //     goToHome();
  //     return <></>;
  //   }
  // }, []);

  const params = useParams();
  //console.log(params);
  async function fetchData() {
    let configrecrut = {
      method: "get",

      url: `${IP}/userCourseDetails/course`,
      params: { courseId: courseId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      // data: "dataregionf",
    };

    const result = await axios(configrecrut);
    //console.log(result.data);
    setCourseInfo(result.data);
    let dueDate = new Date(
      Number(new Date()) +
        1000 * 60 * 60 * 24 * result.data.extraInfo.courseExpirationDays,
    );
    //console.log("due date", dueDate);
    setUserDueDate(dueDate.toDateString());
    if (result.data.extraInfo.quizzes) {
      result.data.extraInfo.quizzes.forEach(async (quizId) => {
        //console.log(quizId);

        let configrecrut = {
          method: "get",

          url: `${IP}/userCourseDetails/quiz`,
          params: { quizId: quizId },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("bearer")}`,
          },
          data: "dataregionf",
        };
        const quizInfo = await axios(configrecrut);
        setCourseQuiz((prev) => prev.concat(quizInfo.data));
      });
    }

    if (result.data?.extraInfo?.lessons) {
      //console.log(quizId);
      let arr = result.data?.extraInfo?.lessons
        ? result.data?.extraInfo?.lessons
        : [];

      let configrecrut = {
        method: "get",

        url: `${IP}/courseBuilder/lesson`,
        params: { id: arr },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        // data: JSON.stringify({ id: arr }),
      };
      axios(configrecrut).then((res) => {
        setLessonsInfo(
          res.data.map((ele, ind) => {
            if (ind == 0) {
              return { ...ele, select: true };
            }
            return { ...ele, select: false };
          }),
        );
      });
    }
  }
  useEffect(() => {
    let configrecrut = {
      method: "get",

      url: `${IP}/userItemDetails/nodeProgress`,
      params: {
        courseId: courseId,
        type: location.state.type ? location.state.type : "",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregionf",
    };
    axios(configrecrut).then((result) => {
      setProgress(result.data);
      if (
        result.data.completed === result.data.total &&
        !result.data.isDisclaimerAccept
      ) {
        setDisclaimerToTrue();
      } else {
        setDisclaimerRead(result.data?.isDisclaimerAccept);
      }
      //console.log(result.data)
    });

    let configrecrutci = {
      method: "get",

      url: `${IP}/userCourse/courseCertificate`,
      params: { courseId: courseId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregionf",
    };
    axios(configrecrutci).then((result) => {
      if (result.data.error) {
        return;
      }
      setCertificateInfo(result.data);
    });
    fetchData();
  }, [disclaimerRead]);

  const [user_courses, setUserCourses] = useState();

  useEffect(() => {
    let configrecrutci = {
      method: "get",

      url: `${IP}/userCourse/`,
      params: { select: 1 },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregionf",
    };
    axios(configrecrutci)
      .then((res) => {
        console.log(res.data);
        // setUserCourses([...res.data]);
        const temp = res.data.find((course) => course.courseId == courseId);
        // console.log(temp);
        setUserCourses(temp);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);
  // //console.log(user_courses);

  // imediate function
  const emiditaeFunc = () => {
    setCookie("user_data", 0);
    if (user_courses) {
      console.log(user_courses);

      let res;
      user_courses.progress.completed == 0
        ? (res = t("Start"))
        : user_courses?.progress.completed == user_courses?.progress.total
          ? (res = t("Completed"))
          : (res = t("Continue"));

      return res;
    } else {
      return t("Start");
    }
  };

  const [expanded, setExpanded] = useState("");

  const setDisclaimerToTrue = () => {
    console.log("clicked");
    const dataregionf = {
      courseId: courseId,
      courseType: "course",
    };
    let configrecrutci = {
      method: "post",
      url: `${IP}/disclaimer/setDisclaimer`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: dataregionf,
    };
    axios(configrecrutci)
      .then((res) => {
        console.log(res.data);
        setDisclaimerRead(true);
      })
      .catch((err) => {
        //console.log(err);
      });
    //  setDisclaimerRead(true);
  };

  const handleChange = (panel) => {
    //console.log(newExpanded);
    setLessonsInfo((prev) =>
      prev.map((ele) => {
        if (ele.id == panel) {
          // console.log(ele.id);
          // console.log(ele);

          // ele.select = ele.select ? false : true;
          //console.log(ele);
          return { ...ele, select: ele.select ? false : true };
        }
        return ele;
      }),
    );
    // setExpanded(panel);
  };

  const [disclaimerReadButton, setDisclaimerReadButton] = useState(false);

  return (
    <Box
      c
      className="hrmainbox"
      sx={{
        backgroundColor: "#F3F1FF",
        "@media (max-width: 780px)": {
          display: "block",
        },
      }}
    >
      <Box className="mobileSideBar_leaning">
        <ResponsiveDrawer sidebar={"Learning"} />
      </Box>
      <Box>
        <MobileTopBar />
        <HrTopNavbar title={"Course content"}>
          <Box>
            <Button
              sx={{
                color: "#6846C7",
                border: "1px solid #6846C7",
                "@media (max-width: 780px)": {
                  display: "none",
                },
              }}
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>
          </Box>
        </HrTopNavbar>
        <Box
          sx={{
            padding: "20px 20px",
            display: "flex",
            gap: "20px",
            minHeight: "90vh",
            "@media (max-width: 780px)": {
              padding: "10px",
              minHeight: "400px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              width: "85vw",
              minWidth: "100%",
              paddingX: "20px",
              borderRadius: "24px",
              overflow: "hidden",
              "@media (max-width: 780px)": {
                flexDirection: "column-reverse",
                backgroundColor: "#FFFFFF",
                gap: "1px",
                height: "400px",
                minHeight: "400px",

                overflow: "scroll",

                // padding: "10px",
              },
              // border: "2px solid red",
            }}
          >
            <Box
              sx={{
                minWidth: "60%",
                borderRadius: "24px",
                width: "60%",
                border: "none",
                "@media (max-width: 780px)": {
                  width: "100%",
                  minWidth: "100%",
                },
                backgroundColor: "#FFFFFF",
                padding: "30px 20px",
              }}
            >
              <Box
                className="sectionname"
                sx={{
                  mb: "18px",
                  color: "#666666",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  fontWeight: "500",
                  border: "none",
                  // backgroundColor: "#FFFFFF",
                }}
              >
                Content
              </Box>

              {/* For disclaimer */}
              {courseInfo?.disclaimer && courseInfo?.disclaimer !== "" && (
                <Accordion
                  expanded={
                    progress?.isDisclaimerAccept
                      ? disclaimerReadButton
                        ? true
                        : false
                      : true
                  }
                  onClick={() => {
                    // setDisclaimerRead(!prev);
                    if (disclaimerReadButton) setDisclaimerReadButton(false);
                    else {
                      setDisclaimerReadButton(true);
                    }
                  }}
                  sx={{
                    border: "none",

                    borderBottom: "1px solid #6846C7",
                    borderTop: "1px solid #FFFFFF",
                    "&:before": {
                      backgroundColor: "#FFFFFF",
                    },
                    py: "12px",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      sx={{
                        color: "#6846C7",
                        // padding: "10px 10px 10px 0px !important",
                        width: "98%",
                        border: "none",
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "20px",
                          fontWeight: "500",
                        }}
                      >
                        {" "}
                        Disclaimer
                      </Typography>
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Typography
                      className="corsediscriptioncontentpage"
                      sx={{
                        color: "#666666",

                        border: "none",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {parse(courseInfo?.disclaimer)}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      {!progress?.isDisclaimerAccept && (
                        <button
                          style={{
                            backgroundColor: "#6846C7",
                            color: "white",
                            border: "none",
                            padding: "10px",
                            borderRadius: "10px",
                          }}
                          onClick={() => {
                            setDisclaimerToTrue();
                          }}
                        >
                          Acknowledge
                        </button>
                      )}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}

              {lessonsInfo?.map((el) => (
                <Accordion
                  expanded={
                    progress?.isDisclaimerAccept
                      ? el?.select
                      : courseInfo.disclaimer
                        ? courseInfo.disclaimer === ""
                          ? el?.select
                          : ""
                        : el?.select
                  }
                  onClick={() => {
                    if (progress?.isDisclaimerAccept) {
                      handleChange(el.id);
                    } else {
                      courseInfo.disclaimer
                        ? console.log("not undefined")
                        : handleChange(el.id);
                    }
                  }}
                  sx={{
                    border: "none",

                    borderBottom: "1px solid #6846C7",
                    borderTop: "1px solid #FFFFFF",
                    "&:before": {
                      backgroundColor: "#FFFFFF",
                    },
                    py: "12px",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      sx={{
                        color: "#6846C7",
                        // padding: "10px 10px 10px 0px !important",
                        width: "98%",
                        border: "none",
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "20px",
                          fontWeight: "500",
                        }}
                      >
                        {" "}
                        {el?.name}
                      </Typography>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      className="corsediscriptioncontentpage"
                      sx={{
                        color: "#666666",

                        border: "none",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {el?.desc}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: "24px",
                }}
              >
                <Box
                  className="corsenameincontentpage"
                  sx={{
                    color: "#6846C7",
                  }}
                >
                  Certificate
                </Box>
                <Box
                  onClick={() => {
                    if (certificateInfo?.certificateDownloadURL) {
                      window.open(
                        certificateInfo?.certificateDownloadURL,
                        "_blank",
                      );
                    }
                  }}
                  sx={{ fill: "#6846C7" }}
                >
                  <img
                    src={Download}
                    style={{
                      opacity: certificateInfo?.certificateDownloadURL
                        ? ""
                        : "0.5",
                    }}
                    alt="Download"
                  />
                </Box>
              </Box>
              {certificateInfo?.certificateDownloadURL && (
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "24px",
                  }}
                >
                  <Button
                    variant="contained"
                    href={buildLinkedInAddToProfileUrl({
                      name: certificateInfo?.certificateName,
                      issuedOn: certificateInfo?.issuedOn,
                      expiry: certificateInfo?.expiry,
                      certId: certificateInfo?.certificateId,
                    })}
                    sx={{
                      bgcolor: "#5B2DAB",
                      width: "100%",
                      p: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                      color: "white",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#4A248B",
                        boxShadow: "none",
                      },
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedIn sx={{ color: "inherit !important" }} />
                    <p
                      style={{
                        fontFamily: "Poppins",
                        color: "#fff",
                      }}
                    >
                      Add to LinkedIn
                    </p>
                  </Button>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                width: "40%",
                borderRadius: "24px",
                "@media (max-width: 780px)": {
                  width: "100%",
                  minWidth: "100%",
                },
              }}
            >
              <Box sx={{ width: "100%" }}>
                <img
                  style={{
                    width: "100%",
                    borderRadius: "16px 16px 16px 16px",
                    border: "1px solid #E8E6DE",
                  }}
                  src={courseInfo?.courseImageURL}
                  alt=""
                />
              </Box>
              <Stack
                spacing={3}
                sx={{
                  padding: "30px 24px",

                  mt: "16px",
                  backgroundColor: "#fff",
                  border: "1px solid #E8E6DE",
                  borderRadius: "16px",
                }}
              >
                <Box
                  className="corsenameincontentpage"
                  sx={{ color: "#4F279B", fontWeight: 600 }}
                >
                  {courseInfo?.courseName}
                </Box>
                <Box
                  className="corsediscriptioncontentpage"
                  sx={{ color: "#4F279B", fontWeight: 600 }}
                >
                  {courseInfo?.courseDescription != undefined
                    ? parse(courseInfo?.courseDescription)
                    : ""}
                </Box>
                <Box>
                  <Box
                    className="corsediscriptioncontentpage"
                    sx={{ my: "10px", color: "#4F279B", fontWeight: 600 }}
                  >
                    {" "}
                    {progress?.total
                      ? Math.ceil((progress?.completed / progress?.total) * 100)
                      : "0"}{" "}
                    % Completed
                  </Box>
                  <ProgressBars
                    progress={progress}
                    sx={{ backgroundColor: "#E4E0F7" }}
                  />
                </Box>
                <Box
                  sx={{
                    "@media (max-width: 780px)": {
                      display: "none",

                      // padding: "10px",
                    },
                  }}
                >
                  {/* <Button>Start</Button> */}

                  {user_courses?.finalStatus == "fail" ? (
                    <Button
                      sx={{
                        color: "#fff",
                        padding: { xs: "10px 20px", md: "10px 40px" },
                        background: "#4F279B",
                        borderRadius: "5px",
                        fontSize: "16px",
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        "&:hover": {
                          background: "#4F279B",
                        },
                      }}
                      onClick={() => {
                        enrollUser(emiditaeFunc(user_courses));
                      }}
                    >
                      Retry
                    </Button>
                  ) : (
                    <Button
                      sx={{
                        color: "#fff",
                        padding: { xs: "10px 20px", md: "10px 40px" },
                        background: "#4F279B",
                        borderRadius: "5px",
                        fontSize: "16px",
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        "&:hover": {
                          background: "#4F279B",
                        },
                      }}
                      onClick={() => {
                        progress?.isDisclaimerAccept
                          ? enrollUser(emiditaeFunc(user_courses))
                          : courseInfo.disclaimer
                            ? courseInfo.disclaimer === ""
                              ? enrollUser(emiditaeFunc(user_courses))
                              : toast.warning(
                                  "Please Acknowledge Disclaimer First !",
                                )
                            : enrollUser(emiditaeFunc(user_courses));
                      }}
                    >
                      {/* {user_courses ? t("continue") : t("Enroll")} */}
                      {emiditaeFunc(user_courses)}
                    </Button>
                  )}
                </Box>
              </Stack>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "none",
            "@media (max-width: 780px)": {
              position: "sticky",
              backgroundColor: "#F3F1FF",
              width: "100%",
              bottom: "0px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // padding: "10px",
            },
          }}
        >
          {/* <Button>Start</Button> */}

          {user_courses?.finalStatus == "fail" ? (
            <Button
              sx={{
                color: "#E1F566",
                padding: { xs: "10px 20px", md: "10px 40px" },
                background: "#4F279B",
                borderRadius: "5px",
                fontSize: "16px",
                fontFamily: "Poppins",
                width: "90%",

                fontWeight: 600,
                "&:hover": {
                  background: "#4F279B",
                },
              }}
              onClick={() => {
                enrollUser(emiditaeFunc(user_courses));
              }}
            >
              Retry
            </Button>
          ) : (
            <Button
              sx={{
                color: "#fff",
                padding: { xs: "10px 20px", md: "10px 40px" },
                background: "#4F279B",
                borderRadius: "5px",
                width: "90%",
                fontSize: "16px",
                fontFamily: "Poppins",
                fontWeight: 600,
                "&:hover": {
                  background: "#4F279B",
                },
              }}
              onClick={() => {
                enrollUser(emiditaeFunc(user_courses));
              }}
            >
              {/* {user_courses ? t("continue") : t("Enroll")} */}
              {emiditaeFunc(user_courses)}
            </Button>
          )}
        </Box>
        <HrFooter />
      </Box>
    </Box>
  );
};
export default CourseContent;
